import styled from "styled-components";

const ToggleRow = styled.li`
  box-sizing: border-box;
  display: flex;
  list-style-type: none;
  border: 2px solid var(--border-color);
  height: 56px;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem;
  font-size: 1rem;
  font-weight: 500;
`;

export { ToggleRow };
